<template>
  <div class="bg">
    <v-card max-width="300">
      <div class="px-10 py-5 d-flex flex-column align-center">
        <h2 class="mb-5">Imposta il tuo username:</h2>
        <v-text-field label="Username" name="displayNameNew" required v-model="displayNameNew"></v-text-field>
        <!-- <v-btn depressed color="secondary" class="pa-4 white--text" @click="save">Conferma</v-btn> -->
        <v-btn depressed :disabled="displayNameNew.length == 0" color="secondary" class="pa-4 white--text"
          @click="save">Conferma</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>

import mixins from '../../js/mixins'
// import { getApp } from 'firebase/app';
import { updateProfile } from 'firebase/auth';
import toast from "../../js/toast";
import Vuex from "vuex";
import Config from '../../../config-app/config';
import { auth, authShared } from '../../../config-firebase/firebase'

// let firebaseApp = getApp(); // [DEFAULT]
// const auth = getAuth(firebaseApp);

// const auth = getAuth();

export default {
  name: 'display-name',
  mixins: [mixins, toast],
  data() {
    return {
      displayNameNew: ''
    }
  },

  methods: {

    save() {

      let displayNameNew = this.displayNameNew.trim();
      if (displayNameNew == '') {
        this.errorToast("Attenzione", "Non hai inserito alcun username.");
        return;
      }

      let nChar = displayNameNew.length;
      let nCharMax = 32;
      if (nChar > nCharMax) {
        this.errorToast("Attenzione", "Username può contenere massimo " + nCharMax + " caratteri. Ne hai inseriti " + nChar);
        return;
      }

      updateProfile(authShared.currentUser, {
        displayName: displayNameNew,
      })
        .then(() => {
          // onAuthStateChange is not fired when updating displayName
          this.$store.dispatch('setUserDisplayName', displayNameNew);
          this.successToast('Username aggiornato', displayNameNew);
          let redirect = this.$route.query.redirect || '/';
          this.$router.push({ path: redirect });
        })
        .catch(() => {
          this.errorToast("Attenzione", "Username non valido. Riprova.");
        })
    }
  },

  computed: {
    ...Vuex.mapGetters(["user_displayName"]),
  },

  mounted() {
    console.log('DisplayName mounted.')
    // init v-model (nn possiamo farlo in data perchè computed viene valorizzato dopo data)
    this.displayNameNew = this.user_displayName
  },

  created() {

  },

  destroyed() {
    console.log('DisplayName destroyed.');
  }
}
</script>

<style lang="scss" scoped>
.bg {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  height: 100%;
}
</style>
